export default "__VITE_ASSET__CuC0cUJh__"